import React, { FC, ReactNode } from "react";

import { Card } from "../Card";
import { Label } from "../Label";

type Props = {
  label: string;
  children: ReactNode;
  dataTest?: string;
};

export const ReadOnlyCardField: FC<Props> = ({ label, children, dataTest }) => {
  return (
    <Label className="grow" label={label} labelClassName="!text-base">
      <Card className="bg-white/50 rounded-lg" dataTest={dataTest}>
        {children}
      </Card>
    </Label>
  );
};
